export default [
  { text: "tipoasamblea.ORDINARIA", value: "ORDINARIA" },
  { text: "tipoasamblea.EXTRAORDINARIA", value: "EXTRAORDINARIA" },
];
